"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLANS = exports.REQUIRED_POINT_CORRECT = void 0;
exports.REQUIRED_POINT_CORRECT = 600;
exports.PLANS = {
    STANDARD: { name: "たけのこ", points: 50 },
    PREMIUM: { name: "神・たけ", points: 100 },
};
